import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Modal } from 'reactstrap';
import { get, post, put, del } from 'helpers/api_helper';
import Datatables from 'pages/utils/table/datatable';
import { ManageCommunicationGroupColumns } from './tableColumns';
import { COMMUNICATION_URL } from 'helpers/url_helper';
import { showSuccessAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';

const ManageCommunicationGroup = () => {
    const [isForm, setIsForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });

    const fetchData = async () => {
        const { success, body } = await get(`${COMMUNICATION_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setLoading(true);
            setRows(body);
            setLoading(false);
        }
    };

    useEffect(fetchData, [pagination]);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const url = editMode ? `${COMMUNICATION_URL}/${editingId}` : COMMUNICATION_URL;
        const method = editMode ? put : post;

        const { success, body } = await method(url, formData);

        if (success) {
            showSuccessAlert(editMode ? 'Communication Group updated successfully!' : 'Communication Group created successfully!');
            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please enter the required fields.");
    };

    const handleEdit = (row) => {
        setFormData(row);
        setEditMode(true);
        setEditingId(row.id);
        setIsForm(true);
        setLoading(false);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} this Communication Group`, `Do you really want to ${action} this Communication Group?`,
            `Yes, ${action} it!`, `${action}d!`, `Communication Group has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${COMMUNICATION_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageCommunicationGroupColumns({ "edit": handleEdit, "delete": handleDelete }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={rows.items || []}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title="All Communication Groups"
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={isForm} toggle={handleToggle} size="xl" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <h5 className="modal-title font-weight-bold">
                            {editMode ? 'Update' : 'Create'} Communication Group
                        </h5>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-4">
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="mb-2">
                                    <AvField
                                        name="title"
                                        label="Communication Group Title *"
                                        type="text"
                                        placeholder="e.g. Diabetic Recall Group, Orthodontic Patients, Routine Checkup 6M"
                                        value={formData.title || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage="Please enter Communication Group title"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleToggle}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Processing...' : (editMode ? 'Update Group' : 'Save Group')}
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
};

export default ManageCommunicationGroup;
